import { handleActions } from 'redux-actions';
import { types } from './user.meta';

export const initialFavoriteMembersState = {
  data: null,
  isFetching: true,
  isFailed: false,
};

export const initialUserSubscriptionState = {
  data: null,
  isFetching: true,
  isFailed: false,
};

export const initialState = {
  authInfo: null,
  ssoData: null,
  status: false,
  favoriteMembers: initialFavoriteMembersState,
  subscription: initialUserSubscriptionState,
};

export const setUserProfile = (state, action) => {
  const { ssoData, status, authInfo } = action.payload;
  return {
    ...state,
    ssoData,
    status,
    authInfo,
  };
};

export const logout = state => ({
  ...state,
  ssoData: null,
  status: false,
});

export const enableFetchingFavoriteMembers = state => {
  return {
    ...state,
    favoriteMembers: {
      ...initialFavoriteMembersState,
      isFetching: true,
    },
  };
};

export const fetchFavoriteMembersCompleted = (state, action) => {
  const { favoriteMembers = [] } = action.payload;
  return {
    ...state,
    favoriteMembers: {
      data: favoriteMembers,
      isFetching: false,
      isFailed: false,
    },
  };
};

export const fetchFavoriteMembersFailed = state => {
  return {
    ...state,
    favoriteMembers: {
      ...initialFavoriteMembersState,
      isFetching: false,
      isFailed: true,
    },
  };
};

export const clearFavoriteMembers = state => ({
  ...state,
  favoriteMembers: initialFavoriteMembersState,
});

export function fetchUserSubscription(state) {
  return {
    ...state,
    subscription: {
      ...state.subscription,
      isFetching: true,
    },
  };
}

export function fetchUserSubscriptionCompleted(state, action) {
  return {
    ...state,
    subscription: {
      data: action.payload,
      isFetching: false,
      isFailed: false,
    },
  };
}

export function fetchUserSubscriptionFailed(state) {
  return {
    ...state,
    subscription: {
      ...initialUserSubscriptionState,
      isFetching: false,
      isFailed: true,
    },
  };
}

export default handleActions(
  {
    [types.SET_USER_PROFILE]: setUserProfile,
    [types.LOG_OUT]: logout,
    [types.FETCH_FAVORITE_MEMBERS]: enableFetchingFavoriteMembers,
    [types.FETCH_FAVORITE_MEMBERS_FAILED]: fetchFavoriteMembersFailed,
    [types.FETCH_FAVORITE_MEMBERS_COMPLETED]: fetchFavoriteMembersCompleted,
    [types.CLEAR_FAVORITE_MEMBERS]: clearFavoriteMembers,
    [types.FETCH_USER_SUBSCRIPTION]: fetchUserSubscription,
    [types.FETCH_USER_SUBSCRIPTION_COMPLETED]: fetchUserSubscriptionCompleted,
    [types.FETCH_USER_SUBSCRIPTION_FAILED]: fetchUserSubscriptionFailed,
  },
  initialState
);
